<template>
    <div v-route-title="'欢迎页面'">
        <h3 v-if="showDefaultPage">欢迎使用{{projectName}}</h3>
    </div>
</template>

<script>
    import {mapGetters, mapState} from 'vuex'
    import portalService from "../service/portal"

    export default {
        name: "MainIndex",
        computed: {
            ...mapState(['user']),
            ...mapGetters(['hasAuthority']),
            projectName() {
                if (this.user && this.user.project) {
                    return this.user.project.name
                } else {
                    return '舆情系统'
                }
            }
        },
        data() {
            return {showDefaultPage: false}
        },
        created() {
            this.init()
        },
        methods: {
            async init() {
                if (this.hasAuthority('T_前台用户')) {
                    const response = await portalService.listPortals({page: 0, size: 1})
                    if (response.data.content.length > 0) {
                        await this.$router.replace('/main/portals/' + response.data.content[0].id)
                        return
                    }
                    if (this.hasAuthority('P_前台_管理_门户')) {
                        await this.$router.replace('/main/portal-admin')
                        return
                    }
                    if (this.hasAuthority('P_前台_管理_栏目')) {
                        await this.$router.replace('/main/section-admin')
                        return
                    }
                    if (this.hasAuthority('P_前台_管理_模板')) {
                        await this.$router.replace('/main/template-admin')
                        return
                    }
                    if (this.hasAuthority('P_前台_管理_数据')) {
                        await this.$router.replace('/main/data-admin')
                        return
                    }
                    if (this.hasAuthority('P_前台_管理_系统')) {
                        await this.$router.replace('/main/user-admin')
                        return
                    }
                } else {
                    if (this.hasAuthority('P_后台_管理_项目')) {
                        await this.$router.replace('/main/project-admin')
                        return
                    }
                    if (this.hasAuthority('P_后台_管理_栏目')) {
                        await this.$router.replace('/main/section-admin')
                        return
                    }
                    if (this.hasAuthority('P_后台_管理_模板')) {
                        await this.$router.replace('/main/template-admin')
                        return
                    }
                    if (this.hasAuthority('P_后台_管理_样式模板')) {
                        await this.$router.replace('/main/view-style-admin')
                        return
                    }
                    if (this.hasAuthority('P_后台_管理_数据')) {
                        await this.$router.replace('/main/data-admin')
                        return
                    }
                    if (this.hasAuthority('P_后台_管理_系统')) {
                        await this.$router.replace('/main/datasource-config-admin')
                        return
                    }
                }
                this.showDefaultPage = true
            }
        }
    }
</script>

<style scoped>

</style>
